import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useControl, useControlActionHistory, useControlReducer } from "../../controlContext";
import { FileText, Info } from "react-feather";
import { ReportBlock } from "../../../../shared/Objects/newReportObjects/reportBlock";
import { useSource, useSourceActionHistory, useSourceReducer } from "../../sourceContext";
import { ReportV2 } from "../../../../shared/Objects/newReportObjects/report_v2";
import { PreambleBlock } from "../../../../shared/Objects/newReportObjects/preambleBlock";
import { dataSource } from "../../../../services/dataSource";
import { CAT, ICN, MAS, NAR, PRE_BLOCK, RAT, REP_BLOCK, REP_IMG, REP_SEC, REP_TPL, REP_V2, SUB, TOP_BLOCK, USR } from "../../../../shared/Data/typeDirs";
import { useNotificationContext } from "../../../revised_components/contextProviders/notificationContext";
import { useNavigate, useBeforeUnload } from "react-router-dom";
// import xlsExport from "../../../../services/reportExports/newExcel"
import htmlExport from "../../../../services/reportExports/html"

// MUI Joy UI imports
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Dropdown from '@mui/joy/Dropdown';
import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import MenuItem from '@mui/joy/MenuItem';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import Sheet from '@mui/joy/Sheet';
import LinearProgress from '@mui/joy/LinearProgress';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SortIcon from '@mui/icons-material/Sort';
import DeleteIcon from '@mui/icons-material/Delete';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded'
import SyncIcon from '@mui/icons-material/Sync';
import { CircularProgress } from '@mui/joy'
import CloudDoneIcon from '@mui/icons-material/CloudDone';

// Import the new ImportModal component
import { ImportModal } from './headerImportModal';

// Import CSS
import '../../../../assets/css/revised_css/components/controlManagerThemes/headerWrappers/reports_v2.css'
import "../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/index.css"
import DataDisplayTable from "../../../dataDisplayTable";
import { getCollectionList, getPhotosByCollection, getSubCollectionsByCollection } from "../../../../services/dbGalleryRequests";
import { useUserContext } from "../../../revised_components/contextProviders/userContext";
import { ReportImage } from "../../../../shared/Objects/newReportObjects/reportImage";
// import { usePhotoManagerContext } from "../../../revised_components/contextProviders/photoManagerContext";
import { ProgressElement } from "../../../revised_components/progressElement";
import { useAppContainerContext } from "../../../revised_components/appContainer/context";
import { flagReportAsTemplate, getThumbnails, requestExcelExport } from "../../../../services/networkRequests";
import { createWebSocketWithToken } from "../../../../services/networkWebsockets";
import { genId } from "../../../../shared/utils";
import { ViewModeToggle } from '../reports_v2/viewModeToggle';
import { OverlayTrigger, Tooltip, Popover, Modal } from "react-bootstrap";
import { NewControlManager } from "../..";
import { ModalContainer } from "../containers/modal";
import { createReportTemplateSchema } from "../../../../shared/Objects/newReportObjects/defaults/createReportTemplateSchema";
import { ConfirmationViewerModal } from "./confirmationViewerModal";

const createReportTemplateNoReportSchema = {
  ...createReportTemplateSchema,
  content: createReportTemplateSchema.content.filter(itm => itm.name !== 'reportContainer')
}

export function ReportHeaderWrapper({ children, objectMetadata, childContainerRef, settings, topBlock, setSettings }) {
  const [showImportModal, setShowImportModal] = useState(false)
  const [showTemplateModal, setShowTemplateModal] = useState(false)
  const [showConfirmationViewerModal, setShowConfirmationViewerModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isReportReady, setIsReportReady] = useState(false) // New state for report readiness
  const [isImporting, setIsImporting] = useState(false)
  const [importMessage, setImportMessage] = useState('')
  const viewModeToggleRef = useRef(null)
  const { user } = useUserContext()
  // const { dbgPhotoManager } = usePhotoManagerContext()
  const { setProgress } = useAppContainerContext()
  const controls = useControl()
  const source = useSource()
  const sourceReducer = useSourceReducer()
  const controlReducer = useControlReducer()
  const displayNotif = useNotificationContext()
  const controlActionHistory = useControlActionHistory()
  const sourceActionHistory = useSourceActionHistory()
  // const navigate = useNavigate()
  // console.log("🟢 ReportHeaderWrapper remount", "settings:", settings);
  const { socket, setRetryTrigger, confirmationHistory } = useReportWS(controlActionHistory, controls, controlReducer, sourceActionHistory, source, sourceReducer, settings, setSettings, objectMetadata, user)


  useEffect(() => {
    console.log('ReportHeaderWrapper | useEffect');
    console.warn('Modified for web version. This function might be broken for some cases.');
    if (!socket) return;
    const handleBeforeUnload = (event) => {
      console.log("UNLOCKING BY USER");
      socket.send(JSON.stringify({
        action_type: 'unlock_by_user',
        control_name: 'closing_websocket',
        file_type: REP_BLOCK,
        file: objectMetadata
      }));
      socket.close(1000);
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    // Cleanup
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [socket, objectMetadata]);


  useEffect(() => {
    if (source.imageMap || loading) return
    setLoading(true)
    console.debug('ReportHeaderWrapper | useEffect [objectMetadata._id]', objectMetadata._id, source.imageMap)
    let timeout_id = setTimeout(async () => {
      let lockedList = await dataSource('remDb')[REP_V2].getReportLockStatus({ _id: objectMetadata._id })
      console.debug('ReportHeaderWrapper | useEffect [objectMetadata._id] | updating imageMap and lockedList', lockedList,)
      if (!timeout_id) return
      let lockMap = {}
      for (let block of lockedList) if (block.locked !== user._id) lockMap[block._id] = block.locked || null
      setSettings({ ...settings, sorted: true, lockMap, retryConnection: true, readOnly: true })
      console.debug(Date.now() + ' Images: entry point. Starting loading');
      let imageMap = await getImageMap(
        controls,
        objectMetadata,
        (status) => progressCallback(status, setProgress),
        user.token,
        // onBatch: update progressively each 25 images
        (deltaMap) => sourceReducer({ type: 'update_imageMap', name: 'header', imageData: deltaMap })
      )
      setProgress(false)
      setLoading(false)
      sourceReducer({ type: 'update_imageMap', name: 'header', imageData: imageMap, lockMap })
    })
    return () => { clearTimeout(timeout_id); timeout_id = null }
  }, [objectMetadata, sourceReducer, setProgress, user, controls, source])

  function selectAction(eventKey) {
    console.log('selectAction with eventKey', eventKey)
    switch (eventKey) {
      case 'add':
        return addReportBlock()
      case 'add_pre':
        return addPreambleBlock()
      case 'save':
        return saveReport()
      case 'export_excel':
        return exportToExcel()
      case 'export_html':
        return exportToHTML()
      case 'dbg_import':
        return setShowImportModal(true)
      case 'check_ws_server_connections':
        return socket.send(JSON.stringify({ action_type: 'status', control_name: '', file_type: '' }))
      case 'close_ws':
        return socket.send(JSON.stringify({ action_type: 'close', control_name: '', file_type: '' }))
      case 'test_error':
        return socket.send(JSON.stringify({ action_type: 'test_error', control_name: '', file_type: '' }))
      case 'restart_queue':
        return socket.send(JSON.stringify({ action_type: 'restart_queue', control_name: '', file_type: '' }))
      case 'save_template':
        return setShowTemplateModal('save')
      case 'flag_template':
        return setShowTemplateModal('flag')
      // case 'stress_test':
      //   return stressTest()
      default: return false
    }
  }


  // function stressTest() {
  //   let block = controls.find(itm => itm[REP_IMG] && itm[REP_IMG].length)
  //   let newControls = []
  //   let newImageData = {}
  //   for (let i = 0; i < 500; i++) {
  //     const _id = genId()
  //     newControls.push({ ...block, _id })
  //     for (let img of block[REP_IMG]) newImageData[_id] = source.imageMap[img._id]
  //   }
  //   controlReducer({
  //     type: 'set_full_controls',
  //     name: 'control-manager-header',
  //     controls: [
  //       ...controls,
  //       ...newControls
  //     ].sort((a, b) => ReportV2.sortAllBlocks(a, b, source))
  //   })
  //   sourceReducer({ type: 'update_imageMap', imageData: newImageData, name: 'control-manager-header' })
  // }

  async function exportToExcel() {
    // let data = mapControlsForOldExports()
    // console.log('exporting with what', data)
    // await xlsExport(data.forest, objectMetadata.dirName, objectMetadata.name)

    requestExcelExport(objectMetadata._id, user.token, objectMetadata.name)
  }

  async function exportToHTML() {
    let data = mapControlsForOldExports()
    console.log('exporting with what', data)
    await htmlExport(
      { report: data.forest, coverPageContent: data.coverPageContent },
      objectMetadata.dirName,
      objectMetadata.name,
      false,
      () => console.log('failed html export'),
      source.imageMap
    )
  }

  function handlePrintToPDF() {
    const { printPreview } = settings

    // If already in print preview, just open the print dialog
    if (printPreview) {
      document.body.click()
      setTimeout(() => window.print(), 100)
      return
    }

    // Call the Print Preview button handler to activate print preview mode
    if (viewModeToggleRef.current) {
      viewModeToggleRef.current.triggerPrintPreview()
    }

    // Then open the browser print window after a delay to allow print preview to render
    document.body.click()
    setTimeout(() => window.print(), 500)
  }


  const mapControlsForOldExports = useCallback(() => {
    const ratingColorMap = ['adb5bd', 'EE3524', 'F7E300', '79C366', '00ABE6']
    return {
      coverPageContent: controls.filter(block => block.type === TOP_BLOCK).map(block => {
        let res = {}
        for (let prop in block) {
          let propName = `cover${prop[0].toUpperCase()}${prop.substr(1)}`
          let val = block[prop]
          if (prop.toLowerCase().includes('photo') || prop === 'signature') {
            val = val && { data: "data:image/jpg;base64, " + source.imageMap[val._id], _id: val._id }
          } else if (prop === 'propertyAddress') {
            propName = 'coverAddress'
          } else if (prop === 'reportType') propName = 'coverRepType'
          res[propName] = val
        }
        res.coverTitle = objectMetadata.name
        return res
      })[0],
      forest: [...controls.filter(block => block.type === PRE_BLOCK).map(block => {
        // console.log('exporting preamble block', block, block.textBlock1, block.textBlock2)
        return {
          title: { content: [{ _name: block.title }] },
          blockName: { content: [{ _name: block.title }] },
          reportSection: { content: [{ _name: 'Top' }] },
          textBlock1: { content: [{ _name: block.textblock1 }] },
          textBlock2: { content: [{ _name: block.textblock2 }] },
          caption: { content: [{ _name: block.caption }] },
          image: { content: [{ _name: block.preambleImage._id }] },

        }
      }), ...controls.filter(block => block.type === REP_BLOCK).map(block => {
        let subcategory = source[SUB].find(item => item._id === block[SUB])
        let category = source[CAT].find(item => item._id === block[CAT])
        let mastercategory = source[MAS].find(item => item._id === block[MAS])
        let reportSection = source[REP_SEC].find(item => item._id === block[REP_SEC])
        let rating = source[RAT].findIndex(item => item._id === block[RAT])
        return {
          blockName: { content: [{ _name: `${subcategory.fullNumber.slice(4)}: ${block.blockName}` }] },
          reportSection: { content: [{ _name: reportSection.getDisplayText() }] },
          subcategory: { content: [{ _name: subcategory._name || subcategory._id, _mask: subcategory.getDisplayText(), [`!fullNum`]: subcategory.fullNumber }] },
          category: { content: [{ _name: category._name || category._id, _mask: category.getDisplayText() }] },
          mastercat: { content: [{ _name: mastercategory._name || mastercategory._id, _mask: mastercategory.getDisplayText() }] },
          narrative: { content: [{ _name: block[NAR].content, _allowExport: block[NAR].isForExport }] },
          recommendation: {
            content: [{
              _name:
                block.recommendations.map(rec => ({
                  ...rec,
                  _icons: rec[ICN] ? rec[ICN].map(itm => ({ _mask: itm, _name: itm })) : [],
                  totalCost: rec.total_cost,
                  unitCost: rec.unit_cost,
                  unitType: rec.unit_type,
                  _name: rec.content
                }))
            }]
          },
          images: { content: [{ _name: block.report_images.map(rep_img => ({ photo: rep_img._id, caption: rep_img.content })) }] },
          rating: { content: [{ _mask: source[RAT][rating].getDisplayText(), _name: ratingColorMap[rating] }] }
        }
      })]
    }
  }, [controls, source])

  function addReportBlock() {
    let block = ReportBlock.createDefaultReportBlock(objectMetadata._id, source)
    controlReducer({ type: 'add_blocks', name: 'control-manager-header', blocks: [block] })
    setSettings({ ...settings, sorted: false })
    // setTimeout(() =>
    //   controlReducer({ type: 'sort_blocks', name: 'control-manager-header', blockId: block._id, sortFn: (a, b) => ReportV2.sortAllBlocks(a, b, source) }),
    //   100)
    // controlReducer({
    //   type: 'set_full_controls',
    //   name: 'control-manager-header',
    //   controls: [
    //     ...controls,
    //     ReportBlock.createDefaultReportBlock(objectMetadata._id, source)
    //   ].sort((a, b) => ReportV2.sortAllBlocks(a, b, source))
    // })
  }

  function addPreambleBlock() {
    let block = PreambleBlock.createDefaultPreambleBlock(objectMetadata._id)
    controlReducer({ type: 'add_blocks', name: 'control-manager-header', blocks: [block] })
    setSettings({ ...settings, sorted: false })
    // setTimeout(() =>
    //   controlReducer({ type: 'sort_blocks', name: 'control-manager-header', blockId: block._id, sortFn: (a, b) => ReportV2.sortAllBlocks(a, b, source) }),
    //   100)
    // controlReducer({
    //   type: 'set_full_controls',
    //   name: 'control-manager-header',
    //   controls: [
    //     ...controls,
    //     PreambleBlock.createDefaultPreambleBlock(objectMetadata._id)
    //   ].sort((a, b) => ReportV2.sortAllBlocks(a, b, source))
    // })
  }

  async function saveReport() {
    try {
      let reportToSave = ReportV2.constructFromMetadataAndControls(objectMetadata, controls)
      console.log('saving this', reportToSave, controls)
      // return
      await dataSource('remDb')[REP_V2].put(reportToSave)
      displayNotif('success', 'Saved Report.')
    } catch (e) {
      displayNotif('danger', `Failed saving report: ${e.message}`)

    }
  }

  async function saveAsTemplate({ controls }) {
    console.log('SAVING as TEMPLATE', controls)
    // return
    let { name, buildingType, description } = controls[0]
    if (!name || !buildingType) {
      return displayNotif('danger', 'Please fill all required fields: "Template Name", "Building Type".')
    }
    try {
      console.log('attempting to save report as template', controls[0])
      let newTemplate = await dataSource('remDb')[REP_TPL].put({ name, buildingType, description, [REP_V2]: objectMetadata._id })
      console.log('made new template', newTemplate)
      setShowTemplateModal(false)
      
    } catch (e) {
      return displayNotif('danger', `Error saving new template: ${e.message}`)
    }
    return displayNotif('success', `New Template Saved!`)
  }

  async function flagAsTemplate({controls}){
    console.log('FLAGGING as TEMPLATE', controls)
    let { name, buildingType, description } = controls[0]
    if (!name || !buildingType) {
      return displayNotif('danger', 'Please fill all required fields: "Template Name", "Building Type".')
    }
    try {
      console.log('attempting to flag this report as template', controls[0])
      let newTemplate = await flagReportAsTemplate( name, buildingType, description, objectMetadata._id, user.token)
      console.log('made new template', newTemplate)
      setShowTemplateModal(false)
    } catch (e) {
      return displayNotif('danger', `Error flagging as template: ${e.message}`)
    }
    return displayNotif('success', `This report has been flagged as a template!`)
  }

  async function importFromDBGallery(rowItem) {
    setIsImporting(true)
    setImportMessage(`Importing images from the ${rowItem.name} collection...`)
    // Optionally keep the toast as well, but we won't rely on it for closing
    displayNotif('info', `Please wait. Importing images from the ${rowItem.name} collection...`);
    console.debug('attempting import', rowItem)
    let subCollections = await getSubCollectionsByCollection(rowItem.id, rowItem.type, user.token)
    if (subCollections?.sets.length == 0) {
      displayNotif('warning', 'No subcollections. This collection do not match report required structure. Try another one.');
      setIsImporting(false)
      return;
    }
    let newBlocks = []
    let currentBlockImages = []
    let imageTotalNumber = 0;
    for (let i = 0; i < subCollections.sets.length; i++) {
      let section = source[REP_SEC].find(srcSec => srcSec.getDisplayText() === subCollections.sets[i].name)
      let sectionPhotos = await getPhotosByCollection(subCollections.sets[i].id, subCollections.sets[i].type, false, user.token)
      // console.log('importing photos for section', i, section, sectionPhotos)
      for (let photo of sectionPhotos.images) {
        let reportBlockData = getReportBlockDataFromDBGalleryImage(photo, section, source, objectMetadata);
        if (reportBlockData == undefined) {
          continue;
        }
        imageTotalNumber++;

        let findBlock = block => {
          if (block.type !== REP_BLOCK) return false
          if ((block[REP_SEC] === section._id) &&
            (block[SUB] === reportBlockData.subcategories)

          ) return true
        }
        let reportBlockExists = controls.find(findBlock)
        let photoExistsInBlock = reportBlockExists && reportBlockExists[REP_IMG].every((rep_img) => rep_img.dbg_id !== photo.id)
        if (photoExistsInBlock) continue
        if (reportBlockExists) {
          currentBlockImages.push(
            new ReportImage({
              _report_blocks: reportBlockExists._id,
              _reports_v2: objectMetadata._id,
              dbg_id: photo.id,
              storageLocation: 'dbgallery'
            })
          )
          continue
        }

        let reportBlock = newBlocks.find(findBlock)
        if (!reportBlock) {
          reportBlock = new ReportBlock(reportBlockData)
          newBlocks = [...newBlocks, reportBlock]
        }

        reportBlock.report_images = [
          ...reportBlock.report_images,
          new ReportImage({ _report_blocks: reportBlock._id, _reports_v2: objectMetadata._id, dbg_id: photo.id, storageLocation: 'dbgallery' })
        ]
      }


    }

    if (imageTotalNumber == 0) {
      displayNotif('warning', 'Nothing to import. The collection seems to be empty. Try another one.');
      setIsImporting(false)
      return;
    }

    let newControls = [...controls]
    for (let image of currentBlockImages) {
      let blockIdx = newControls.findIndex(block => block._id === image._report_blocks)
      newControls = [
        ...newControls.slice(0, blockIdx),
        { ...newControls[blockIdx], report_images: [...newControls[blockIdx].report_images, image] },
        ...newControls.slice(blockIdx + 1)
      ]
    }
    newControls = [...newControls, ...newBlocks].sort((a, b) => ReportV2.sortAllBlocks(a, b, source))
    // console.log('about to set controls', newControls)
    controlReducer({ type: 'set_full_controls', name: 'import', controls: newControls })
    let queueItems = [...currentBlockImages, ...newBlocks.reduce((acc, cur, idx) => ([...acc, ...cur.report_images]), [])]
    // await dataSource('remDb')[REP_IMG].bulkInsert(queueItems)
    // queueItems = queueItems.map(photo => {
    //   let { _id, type: typeDir, dbg_id } = photo
    //   return { _id, typeDir, dbg_id }
    // })

    let imageMap = await getImageMap(
      newControls,
      objectMetadata,
      (status) => progressCallback(status, setProgress),
      user.token,
      // onBatch: update progressively each 25 images
      (deltaMap) => sourceReducer({ type: 'update_imageMap', name: 'import', imageData: deltaMap })
    )
    setProgress(false)
    sourceReducer({
      type: 'update_imageMap', name: 'import', imageData: imageMap, photo_update: queueItems.map(photo => {
        let { _id, thumbnailSize, dbg_id, storageLocation } = photo
        return { _id, thumbnailSize, dbg_id, storageLocation }
      })
    })

    setIsImporting(false)
    displayNotif('success', `The import is finished successfully. ${imageTotalNumber} images are imported from the ${rowItem.name} colletion`);
  }

  // Show loader until WebSocket is connected and report is ready
  const showLoader = !isReportReady;

  // Update report ready state when WebSocket connection is established
  useEffect(() => {
    if (settings.isConnected && !isReportReady) {
      // Add a small delay to ensure everything is properly initialized
      const timer = setTimeout(() => {
        setIsReportReady(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [settings.isConnected, isReportReady]);

  return (
    <>
      {/* Unified Progress Bar - Full Width at Top */}
      {(showLoader || isImporting) && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            width: '100%',
            backgroundColor: '#d8e6e5'
          }}
        >
          <LinearProgress
            sx={{
              height: '4px',
              '--LinearProgress-color': '#589A99',
              '--LinearProgress-trackColor': 'rgba(88, 154, 153, 0.2)',
              '--LinearProgress-thickness': '4px'
            }}
          />
          <Box
            sx={{
              position: 'fixed',
              top: '14px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <Typography
              level="body-sm"
              sx={{
                color: '#174041',
                fontWeight: 500,
                fontSize: '13px',
                backgroundColor: '#d8e6e5',
                px: 1.5,
                py: 1.0,
                borderRadius: '41px',
                border: 'none',
                height: '34px'
              }}
            >
              {isImporting
                ? importMessage
                : (!settings.isConnected ? 'Connecting to server...' : 'Loading report...')
              }
            </Typography>
          </Box>
        </Box>
      )}

      <Sheet
        className="header-sheet"
        sx={{
          p: 1,
          borderRadius: 'none',
          backgroundColor: '#d8e6e5',
          borderBottom: '1px solid',
          borderColor: 'divider',
          height: '52px'
        }}
      >
        {!showLoader && (



          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 1,
              alignItems: { xs: 'stretch', sm: 'center' },
              flexWrap: 'wrap'
            }}
            className="header-wrapper-custom"
          >
            {/* Actions Dropdown */}
            <Box sx={{ flexShrink: 0 }}>
              <Dropdown>
                <MenuButton
                  variant="outlined"
                  size="sm"
                  startDecorator={<FileText size={20} />}
                  endDecorator={<KeyboardArrowDownIcon />}
                  className="btn-custom-primary btn-responsive"
                >
                  Actions
                </MenuButton>
                <Menu>
                  <MenuItem onClick={() => selectAction('add')}>
                    <AddIcon sx={{ mr: 1 }} />
                    Add Report Block
                  </MenuItem>
                  <MenuItem onClick={() => selectAction('add_pre')}>
                    <AddIcon sx={{ mr: 1 }} />
                    Add Preamble Block
                  </MenuItem>
                  <MenuItem onClick={() => selectAction('export_excel')}>
                    <FileDownloadIcon sx={{ mr: 1 }} />
                    Export to Excel
                  </MenuItem>
                  <MenuItem onClick={handlePrintToPDF}>
                    <FileDownloadIcon sx={{ mr: 1 }} />
                    Print to PDF
                    <OverlayTrigger
                      trigger={['hover', 'click']}
                      overlay={
                        <Tooltip>Select "Save as PDF" from  "Destination" dropdown. For best results print from Chrome on Desktop.</Tooltip>
                      }>
                      <Info />
                    </OverlayTrigger>
                  </MenuItem>
                  <MenuItem onClick={() => selectAction('dbg_import')}>
                    <CloudUploadIcon sx={{ mr: 1 }} />
                    Import Images from DBGallery
                  </MenuItem>
                  <MenuItem onClick={() => selectAction('save_template')}>
                    Save as Template
                    <OverlayTrigger
                      trigger={['hover', 'click']}
                      overlay={
                        <Tooltip>Copies categorized blocks to a new Report Template without data.</Tooltip>
                      }>
                      <Info />
                    </OverlayTrigger>
                  </MenuItem>
                  <MenuItem onClick={() => selectAction('flag_template')}>
                    Flag as Template
                    <OverlayTrigger
                      trigger={['hover', 'click']}
                      overlay={
                        <Tooltip>Flags current open Report as a Template.</Tooltip>
                      }>
                      <Info />
                    </OverlayTrigger>
                  </MenuItem>
                  <MenuItem onClick={() => selectAction('restart_queue')}>
                    Restart Server Queue
                  </MenuItem>
                </Menu>
              </Dropdown>
              <ViewModeToggle
                ref={viewModeToggleRef}
                settings={settings}
                setSettings={setSettings}
                controls={controls}
                controlReducer={controlReducer}
              />
            </Box>





            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                flexWrap: 'wrap',
                minWidth: { xs: '100%', sm: 'auto' },
                flexGrow: 1,
                justifyContent: 'end'
              }}
            >
              {!confirmationHistory.errors.length ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Button size="sm" variant="outlined" color="success" onClick={()=>setShowConfirmationViewerModal(true)}>
                    <CheckCircleIcon sx={{ fontSize: '16px', color: '#28a745' }} />
                    <Typography level="body-sm" sx={{ color: '#28a745', fontWeight: 'md' }}>
                      No Issues Detected
                    </Typography>
                  </Button>
                  <Typography level="body-sm" sx={{ color: '#28a745', fontWeight: 'md' }}>
                    {confirmationHistory.history && confirmationHistory.history.length ?
                      ' | Last save confirmation : ' + new Date(
                        confirmationHistory.history.find(itm => !itm.error && itm.action.client_completed_time).action.client_completed_time
                      ).toLocaleString() : ''}
                  </Typography>

                </Box>
              ) : (
                  <Button
                    variant="outlined"
                    color="danger"
                    size="sm"
                    startDecorator={<DangerousRoundedIcon sx={{ fontSize: '16px', color: '#c21414' }} />}
                    onClick={()=>setShowConfirmationViewerModal(true)}
                  >
                    {confirmationHistory.errors.length} Errors Detected
                  </Button>
              )}
              <Typography level="body-sm" sx={{ color: 'text.tertiary' }}>
                |
              </Typography>

              {settings.isConnected ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <WifiIcon sx={{ fontSize: '16px', color: '#28a745' }} />
                  <Typography level="body-sm" sx={{ color: '#28a745', fontWeight: 'md' }}>
                    Connected to Server
                  </Typography>
                </Box>
              ) : (

                <Button
                  variant="soft"
                  size="sm"
                  color="danger"
                  startDecorator={<WifiOffIcon />}
                  onClick={() => {

                    setRetryTrigger(true) // Trigger the effect
                    console.log("🟡 BUTTON CLICKED - retryConnection set to true and trigger incremented");

                  }}
                  className={`btn-responsive  btn-custom-danger-outline`}
                >
                  DISCONNECTED - Retry Connection?
                </Button>
              )}
              <Typography level="body-sm" sx={{ color: 'text.tertiary' }}>
                |
              </Typography>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                <Typography level="body-sm" sx={{ color: 'text.primary', fontWeight: 'md' }}>
                  Collaborative Actions:
                </Typography>
                {settings.sorted && !settings.deleteQueue && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <CheckCircleIcon sx={{ fontSize: '16px', color: '#28a745' }} />
                    <Typography level="body-sm" sx={{ color: '#28a745', fontWeight: 'md' }}>
                      Synced
                    </Typography>
                  </Box>
                )}
                <Box sx={{ display: 'flex', gap: 1 }}>
                  {!settings.sorted && (

                    <Button
                      disabled={settings.sorted}
                      variant={!settings.sorted ? 'outlined' : 'soft'}
                      size="sm"
                      startDecorator={<SortIcon />}
                      onClick={() => {
                        setSettings({ ...settings, sorted: true })
                        controlReducer({ type: 'sort_blocks', blockId: topBlock, name: 'websocket', sortFn: (a, b) => ReportV2.sortAllBlocks(a, b, source) })
                      }}
                      className={`btn-responsive ${!settings.sorted ? 'btn-custom-danger-outline' : 'btn-custom-primary-solid'}`}
                    >
                      {!settings.sorted ? 'Sort Requested' : 'Blocks Sorted'}
                    </Button>
                  )}
                  {settings.deleteQueue && (
                    <Button
                      variant={settings.deleteQueue ? 'outlined' : 'soft'}
                      disabled={!settings.deleteQueue}
                      size="sm"
                      startDecorator={<DeleteIcon />}
                      onClick={() => {
                        setSettings({ ...settings, sorted: true, deleteQueue: false })
                        for (let blockToDelete of settings.deleteQueue) {
                          controlReducer({ type: 'delete_block', name: 'websocket', file: { _id: blockToDelete } })
                        }
                      }}
                      className={`btn-responsive ${settings.deleteQueue ? 'btn-custom-danger-outline' : 'btn-custom-primary-solid'}`}
                    >
                      {!settings.deleteQueue ? 'Nothing to delete' : 'Delete Requested'}
                    </Button>
                  )}


                </Box>

              </Box>
            </Box>



            <Box sx={{ flexShrink: 0 }}>
              {children}
            </Box>



          </Box>

        )}
      </Sheet>

      <ImportModal
        key={`${showImportModal}`}
        open={showImportModal}
        onClose={() => setShowImportModal(false)}
        onClickEntry={(item) => {
          setShowImportModal(false)
          importFromDBGallery(item)
        }}
      />
      <ConfirmationViewerModal
        show={showConfirmationViewerModal}
        setShow={setShowConfirmationViewerModal}
        confirmationHistory={confirmationHistory} />
      <NewControlManager
        onSubmit={showTemplateModal === 'save'? saveAsTemplate: flagAsTemplate }
        content={[{ name: objectMetadata.name, buildingType: '' }]}
        schemas={[createReportTemplateNoReportSchema]}
        source={{}}
        objectMetadata={{ type: 'Report Template' }}
        options={{
          modules: { container: ModalContainer }, show: !!showTemplateModal,
          setShow: setShowTemplateModal, isModal: true
        }}
      />
    </>
  )
}

function getDBGalleryPhotoCategory(photo) {
  let subcategory = photo.imageCustomMetadatas.find(itm => itm.customMetadataDefinition.label === 'Recognition Code')
  subcategory = subcategory && subcategory.dataValue
  return subcategory
}


function getReportBlockDataFromDBGalleryImage(photo, section, source, reportMetadata) {
  try {
    let subcategory = getDBGalleryPhotoCategory(photo)
    console.debug('Getting image data from dbgallery: ', subcategory, subcategory.split(' ')[0], source[SUB], photo, section, reportMetadata)
    subcategory = source[SUB].find(srcSub => srcSub.fullNumber.includes(subcategory.split(' ')[0]))
    console.debug('Subcategory is got: ', subcategory)
    let category = source[CAT].find(srcCat => srcCat._id === subcategory._categories)
    let mastercategory = source[MAS].find(srcMas => srcMas._id === category._mastercategories)

    return {
      [SUB]: subcategory._id,
      [CAT]: category._id,
      [MAS]: mastercategory._id,
      [REP_SEC]: section._id,
      [RAT]: source[RAT][0]._id || null,
      blockName: subcategory.content,
      _reports_v2: reportMetadata._id,
    }
  }
  catch (ex) {
    console.debug(`Image ${photo.id} is skipped. Failed to process image categorization data.`);
    return undefined;
  }
}

async function getImageMap(controls, objectMetadata, progressCallback, userToken, onBatch) {
  console.debug('getting imageMap')
  let mockReport = new ReportV2({
    [REP_BLOCK]: controls.filter(block => block.type === REP_BLOCK),
    [TOP_BLOCK]: controls.filter(block => block.type === TOP_BLOCK)[0],
    [PRE_BLOCK]: controls.filter(block => block.type === PRE_BLOCK),
    ...objectMetadata
  })
  let imageMap = await mockReport.getImageMap(userToken, getThumbnails, progressCallback, dataSource, onBatch)
  console.debug('setting imageMap', imageMap)
  return imageMap
}

async function progressCallback(status, setProgress) {
  setProgress(
    ProgressElement(status.num, status.den, `Getting images: (${status.num} / ${status.den})`)
  )
}

function useReportWS(actionHistory, controls, controlReducer, sourceHistory, source, sourceReducer, settings, setSettings, objectMetadata, user) {
  const [socket, setSocket] = useState()
  const [lastExecutedActionId, setLastExecutedActionid] = useState()
  const [retryTrigger, setRetryTrigger] = useState(true)
  const [confirmationHistory, setConfirmationHistory] = useState({ errors: [], history: [] })

  // const history = useHistory()

  // useEffect(() => {
  //   if (socket) {
  //     console.log('useReportSocket | useEffect[history]: closing socket')
  //     socket.close(1000)
  //     setSocket(null)
  //   }
  // }, [history])
  const init = useCallback(() => {
    console.log("🔴 EFFECT RUNNING - socket creation on client side", "retryConnection:", retryTrigger, "socket:", !!socket, "retryTrigger:", retryTrigger);
    if (!retryTrigger) {
      console.log("🔴 EFFECT EXITING - retryConnection is false");
      return
    }

    // If there's already a socket and retryConnection is true, close it first
    if (socket) {
      console.log("closing existing socket for retry");
      socket.close(1000);
      setSocket(null);
    }

    console.log("socket creation on client side 2");
    const sock = createWebSocketWithToken(user);

    // sock.addEventListener('')
    sock.addEventListener('open', (evt) => {
      console.log('Report WEBSOCKET init, opened', evt)
      sock.addEventListener('message', (evt) => {
        let message = JSON.parse(evt.data)
        console.log('in onopen onmessage', message)
        if (message.type === 'ready') {
          sock.send(JSON.stringify({ reportId: objectMetadata._id }))
          setSettings({ ...settings, isConnected: true, readOnly: false })
          setRetryTrigger(false)
        }
      })
      // sock.send(JSON.stringify({ action_type: 'test', file: 'hello hello' }))
      // sock.close(1000)
    })
    sock.addEventListener('ping', () => console.log('got websocket ping'))
    sock.addEventListener('pong', () => console.log('got websocket pong'))
    sock.addEventListener('close', (evt) => {

      setSettings({ ...settings, isConnected: false, readOnly: true })
      setSocket(null)
      console.log('closing websocket', evt)
    })

    setSocket(sock)
  }, [user, retryTrigger, settings, objectMetadata])
  useEffect(() => {
    let timeout_id = setTimeout(() => init(), 500)
    return () => clearTimeout(timeout_id)
  }, [init, settings, retryTrigger])

  useEffect(() => {
    if (!socket) return
    const getChangedAction = (action, ctrls) => {
      // let fileId = action.file[`_${REP_BLOCK}`] || action.file[`_${PRE_BLOCK}`] || action.file[`_${TOP_BLOCK}`] || action.file._id
      let fileId = [REP_BLOCK, PRE_BLOCK, TOP_BLOCK].includes(action.file_type) ? action.file._id :
        Array.isArray(action.remote_action.update[action.remote_action.name]) ?
          action.remote_action.update[action.remote_action.name][0][`_${REP_BLOCK}`] ||
          action.remote_action.update[action.remote_action.name][0][`_${PRE_BLOCK}`] ||
          action.remote_action.update[action.remote_action.name][0][`_${TOP_BLOCK}`] :
          action.remote_action.update[action.remote_action.name][`_${REP_BLOCK}`] ||
          action.remote_action.update[action.remote_action.name][`_${PRE_BLOCK}`] ||
          action.remote_action.update[action.remote_action.name][`_${TOP_BLOCK}`]

      console.log('got file id', fileId)
      let idx = ctrls.findIndex(itm => itm._id === fileId)
      // console.log('got update, sending action', idx, action, controls)
      let blockEdit = action.remote_action.value ?
        { [action.remote_action.name]: action.remote_action.value } : action.remote_action.update
      return { type: 'changed', name: 'websocket', idx, update: { ...ctrls[idx], ...blockEdit } }
    }
    const messageListener = (message) => {
      try {
        let action = JSON.parse(message.data)
        console.log('useReportWS | on message: ', action)

        switch (action.action_type) {
          case "confirmation":
            let client_completed_time = Date.now()
            action = { ...action, action: { ...action.action, client_completed_time } }
            action = { ...action, action: { ...action.action, client_completed_time } }
            console.log('got action confirmation', action, confirmationHistory)
            setConfirmationHistory({
              ...confirmationHistory,
              errors: action.error ? [action, ...confirmationHistory.errors] : confirmationHistory.errors,
              history: [action, ...confirmationHistory.history].slice(0, 50)
            })
            break;
          case "lock":
            setSettings({ ...settings, lockMap: { ...settings.lockMap, [action.file._id]: action.user } })
            break;
          case "unlock":
            setSettings({ ...settings, lockMap: { ...settings.lockMap, [action.file._id]: false } })
            break;
          case "update":
            let changedAction = getChangedAction(action, controls)
            controlReducer(changedAction)
            break;
          case "create":
            // let createFn = action.file_type === REP_BLOCK ? ReportBlock.createDefaultReportBlock : PreambleBlock.createDefaultPreambleBlock
            if (action.remote_action.type === 'changed') {
              let changedAction = getChangedAction(action, controls)
              controlReducer(changedAction)
            } else {
              setTimeout(() => controlReducer({
                type: 'add_blocks',
                name: 'websocket',
                blocks: action.file
              })
              )
            }
            break;
          case "photo_update":
            // console.log('INCOMING PHOTO UPDATE', action)
            setTimeout(async () => {
              let imageData = {}
              let res = await getThumbnails(action.photo_update, user.token)
              for (const element of res) imageData[element.metadata.name.split('.')[0]] = element.thumbnail

              sourceReducer({ type: 'update_imageMap', name: 'websocket', imageData })
            })
            break;
          case "sort_blocks":
            setSettings({ ...settings, sorted: false })
            break;
          case "kill":
            setSettings({ ...settings, deleteQueue: settings.deleteQueue ? [...settings.deleteQueue, action.file._id] : [action.file._id] })
            break;
          case "import":
            let newControls = []
            for (let importBlock of action.file) {
              let oldBlock = controls.find(itm => itm.id === importBlock._id)
              let newBlock = oldBlock ? { ...oldBlock, [REP_IMG]: importBlock[REP_IMG] } : importBlock
              newControls.push(newBlock)
            }
            let topBlocks = controls.filter(itm => [TOP_BLOCK, PRE_BLOCK].includes(itm.type))
            let repBlocks = newControls.filter(itm => itm.type === REP_BLOCK)
            newControls = [...topBlocks, ...repBlocks]
            controlReducer({ type: 'set_full_controls', name: 'websocket', controls: newControls })
            break;
          case "unlock_by_user":
            let { lockMap } = settings
            let newLockMap = {}
            for (let key in lockMap) newLockMap[key] = lockMap[key] === action.user ? false : lockMap[key]
            setSettings({ ...settings, lockMap: newLockMap })
            break;
          default:
            console.log('DEFAULT CASE IN WEBSOCKET ACTION', action)
            return
        }
      } catch (e) {
        console.log('Report WEBSOCKET | Failed parsing incoming action JSON', e)
      }
    }
    socket.addEventListener('message', messageListener)
    return () => socket.removeEventListener('message', messageListener)
  }, [socket, settings, controls, controlReducer, sourceReducer, confirmationHistory])

  useEffect(() => {
    let [last_action] = actionHistory
    if (!last_action ||
      last_action.type === '_init' ||
      last_action.name === 'websocket' ||
      last_action.actionId === lastExecutedActionId
    ) return

    console.log('sending action over websocket', last_action)
    const getWebSocketAction = (action_type, remote_action, file, file_type, control_name, userId, photo_update) => (
      JSON.stringify({ action_type, remote_action, file, file_type, control_name, userId, photo_update, client_start_time: Date.now() })
    )
    const relevant_action_type = last_action.childAction ? last_action.childAction.type : last_action.type
    switch (relevant_action_type) {
      case 'changed':
        if (settings.lockedBlock !== controls[last_action.idx]._id) {
          if (settings.lockedBlock) {
            let lockedBlock = controls.find(itm => itm._id === settings.lockedBlock)
            socket.send(getWebSocketAction('unlock', last_action, lockedBlock, lockedBlock.type, 'websocket'))

          }
          socket.send(getWebSocketAction(
            'lock',
            last_action,
            controls[last_action.idx],
            controls[last_action.idx].type,
            last_action.name,
            user._id
          ))
          console.log('locked block for user', user)
          setSettings({ ...settings, lockedBlock: controls[last_action.idx]._id })
        }

        let file, controlName, update
        if (last_action.childAction) {
          file = last_action.childAction.idx || last_action.childAction.idx === 0 ?
            controls[last_action.idx][last_action.name][last_action.childAction.idx] : controls[last_action.idx][last_action.name]
          update = last_action.childAction.update
          controlName = last_action.childAction.name

        } else {
          file = controls[last_action.idx]
          controlName = last_action.name
          update = last_action.update
        }

        console.log('sending update', file, controlName, last_action)

        socket.send(getWebSocketAction(
          'update',
          last_action,
          { _id: file._id, ...update },
          file.type,
          controlName,
          null,
          last_action.photo_update
        ))
        break;
      case 'add_blocks':
        let blocks, file_type, control_name
        if (last_action.childAction) {
          blocks = last_action.childAction.blocks
          file_type = blocks[0].type
          control_name = last_action.childAction.name
        } else {
          blocks = last_action.blocks
          file_type = blocks[0].type
          control_name = last_action.name
        }
        console.log('sending blocks to add over websocket', blocks, file_type, control_name, last_action)
        socket.send(getWebSocketAction(
          'create',
          last_action,
          blocks,
          file_type,
          control_name
        ))
        break;
      case 'sort_blocks':
        socket.send(getWebSocketAction(
          'sort_blocks',
          last_action,
          null,
          last_action.name || last_action.idx || controls[last_action.idx].type,
          last_action.name
        ))

        break;
      case 'lock':
        setSettings({ ...settings, lockedBlock: last_action.file._id })
        socket.send(getWebSocketAction(
          'lock',
          last_action,
          last_action.file,
          controls[last_action.idx].type,
          last_action.name,
          user._id
        ))
        break;
      case 'unlock':
        let { [last_action.file._id]: lockedEntry, ...rest } = settings.lockMap
        console.log('unlocking a block', settings, last_action)
        // return
        setSettings({ ...settings, lockedBlock: last_action.file._id === settings.lockedBlock ? false : settings.lockedBlock, lockMap: rest })
        socket.send(getWebSocketAction(
          'unlock',
          last_action,
          last_action.file,
          controls[last_action.idx].type,
          last_action.name,
          user._id

        ))

        break;
      case 'delete_block':
        let fileToDelete, type, control
        if (last_action.childAction) {
          fileToDelete = last_action.childAction.file
          type = fileToDelete.type
          control = last_action.childAction.name
        } else {
          fileToDelete = last_action.file
          type = fileToDelete.type
          control = last_action.name
        }
        if (type === REP_BLOCK) setSettings({ ...settings, lockedBlock: false })
        socket.send(getWebSocketAction('kill', last_action, fileToDelete, type, control))

        break;
      case 'set_full_controls':
        socket.send(getWebSocketAction('import', last_action, last_action.controls, REP_BLOCK, 'import'))

        break;
    }

    setLastExecutedActionid(last_action.actionId)
  }, [controls, actionHistory, user])

  useEffect(() => {
    // console.log('RUNNING SOURCEHISTORY CHANGED', sourceHistory)
    if (!source.imageMap ||
      !sourceHistory.length ||
      sourceHistory[0].type === '_init' ||
      sourceHistory[0].name === 'websocket' || sourceHistory[0].name === 'header') return

    // console.log('SENDING PHOTO UPDATE ACTION TO SERVER', sourceHistory)
    socket.send(JSON.stringify({
      action_type: 'photo_update',
      control_name: sourceHistory[0].name,
      photo_update: sourceHistory[0].photo_update,
      file_type: sourceHistory[0].name,
    }))
  }, [sourceHistory])

  return { socket, setRetryTrigger, confirmationHistory }
}
